export var AppointmentErrorType;
(function (AppointmentErrorType) {
    AppointmentErrorType["appointmentDoNotExist"] = "appointmentDoNotExist";
    AppointmentErrorType["appointmentWasCanceled"] = "appointmentWasCanceled";
})(AppointmentErrorType || (AppointmentErrorType = {}));
